import { useEffect, useState } from 'react';
import { notification, Button, Form, Modal, Select } from 'antd';
import ApiService from '../../../services/ApiService';

export const SchoolStudentModal = ({ school, members, student, onClose, onSave }) => {
  const [api, contextHolder] = notification.useNotification();
  const [form] = Form.useForm();
  const [isSubmitting, setSubmitting] = useState(false);

  const memberOptions = members.map(member => ({
    label: `${member.firstName} ${member.lastName} (${member.userName})`,
    value: member.userId,
  }));

  const onFinish = async values => {
    setSubmitting(true);
    try {
      await ApiService.addSchoolStudent(school.schoolId, values.userId);
      onSave();
    } catch (e) {
      api.open({
        message: 'Sorry...',
        description: 'Something went wrong...',
      });
    }
    setSubmitting(false);
  };

  useEffect(() => {
    form.resetFields();
  }, [form, student]);

  return (
    <Modal
      title="Add Student"
      open={!!student}
      onCancel={onClose}
      footer={[
        <Button key="save" type="primary" loading={isSubmitting} onClick={() => form.submit()}>
          Add
        </Button>,
      ]}
    >
      {contextHolder}
      <Form
        layout="vertical"
        initialValues={student}
        form={form}
        onFinish={onFinish}
        requiredMark={false}
        autoComplete="off"
      >
        <Form.Item
          label="Student"
          name="userId"
          rules={[
            {
              required: true,
              message: 'Student is required!',
            },
          ]}
        >
          <Select showSearch placeholder="Select a student" optionFilterProp="label" options={memberOptions} />
        </Form.Item>
        <Form.Item className="d-none">
          <Button type="primary" htmlType="submit"></Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};
